import React from 'react';
import { Package, Edit, Trash2 } from 'lucide-react';

const getStatusColor = (status) => {
  switch (status) {
    case 'available':
      return 'bg-green-100 text-green-800';
    case 'reserved':
      return 'bg-yellow-100 text-yellow-800';
    case 'sold':
      return 'bg-red-100 text-red-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

const WarehouseCard = ({ warehouse, onEdit, onDelete }) => {
  return (
    <div
      data-testid={`warehouse-card-${warehouse.id}`}
      className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow"
    >
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="bg-amber-100 p-2 rounded-lg">
            <Package className="w-6 h-6 text-amber-600" />
          </div>
          <div>
            <h3 className="font-semibold text-gray-900">Unit {warehouse.unit_number}</h3>
            <span className={`inline-block px-2 py-1 rounded-full text-xs font-semibold mt-1 ${getStatusColor(warehouse.status)}`}>
              {warehouse.status}
            </span>
          </div>
        </div>
        <div className="flex gap-2">
          <button
            onClick={() => onEdit(warehouse)}
            className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
            data-testid={`edit-warehouse-${warehouse.id}`}
          >
            <Edit className="w-4 h-4" />
          </button>
          <button
            onClick={() => onDelete(warehouse.id)}
            className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
            data-testid={`delete-warehouse-${warehouse.id}`}
          >
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      </div>

      <div className="space-y-2 text-sm">
        <div className="flex justify-between">
          <span className="text-gray-600">Area:</span>
          <span className="font-medium text-gray-900">{warehouse.area_sqm} m2</span>
        </div>
        {warehouse.price && (
          <div className="flex justify-between">
            <span className="text-gray-600">Price:</span>
            <span className="font-medium text-gray-900">${warehouse.price.toLocaleString()}</span>
          </div>
        )}
        {warehouse.features.length > 0 && (
          <div className="mt-3">
            <span className="text-gray-600 text-xs">Features:</span>
            <div className="flex flex-wrap gap-1 mt-1">
              {warehouse.features.slice(0, 3).map((feature) => (
                <span
                  key={feature}
                  className="bg-gray-100 text-gray-700 px-2 py-1 rounded text-xs"
                >
                  {feature}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default WarehouseCard;
